import * as $ from 'jquery';
import 'jquery-validation';
import InputMask from './input-mask';
// Mask validation
$.validator.addMethod("mask", function (value, element, regexp) {
    var re = new RegExp(regexp);
    return this.optional(element) || re.test(value);
}, "Invalid format");
// form-error-summary
// close form error when clicking on the close icon
$(".form-error-summary").on("click", ".close-icon", function () {
    $(this).closest(".form-error-summary").hide();
});
// validation
// simple form validation on submit
// <form novalidate>
jQuery.validator.setDefaults({
    ignore: ".validation-ignore *",
    errorElement: 'span',
    errorPlacement: function (error, element) {
        // prepare error element
        error.addClass('invalid-feedback');
        // get validation group
        // if element belongs to .validation-group then display validation group message
        let validationMessageContainer = $(element).closest(".validation-group");
        // else display inline error message
        if (validationMessageContainer.length <= 0) {
            validationMessageContainer = element.parent();
        }
        let errorElement = validationMessageContainer.children(".invalid-feedback");
        // if feedback is not exist then add a default one
        if (errorElement.length <= 0) {
            validationMessageContainer.append(error);
        }
        else {
            // error message element exists
            // get real error text
            const errorText = error.text();
            // If required validation message
            if (errorText == 'This field is required.') {
                // use default message
                if (errorElement.data("default") && errorElement.data("default").length > 0) {
                    errorElement.text(errorElement.data("default"));
                }
            }
            else {
                // save default text if not exist
                if (!errorElement.data("default") || errorElement.data("default").length <= 0)
                    errorElement.data("default", errorElement.text());
                // set override message
                errorElement.text(errorText);
            }
        }
    },
    highlight: function (element, errorClass, validClass) {
        // get validation group
        // if element belongs to .validation-group then display validation group message
        let validationMessageContainer = $(element).closest(".validation-group");
        // else display inline error message
        if (validationMessageContainer.length > 0) {
            validationMessageContainer.addClass('is-invalid');
        }
        else {
            // add invalid class to input
            $(element).addClass('is-invalid');
        }
    },
    unhighlight: function (element, errorClass, validClass) {
        // get validation group
        // if element belongs to .validation-group then display validation group message
        let validationMessageContainer = $(element).closest(".validation-group");
        // else display inline error message
        if (validationMessageContainer.length > 0) {
            // remove invalid class to input
            validationMessageContainer.removeClass('is-invalid');
        }
        else {
            // remove invalid class to input
            $(element).removeClass('is-invalid');
        }
    }
});
// init validator
const validator = $("form").validate();
// catch custom validation event from inside of the form
$('form').on('validate', 'input', function (e) {
    $("form").validate().element(e.target);
});
$(document).on('submit', 'form', function (e) {
    if (!$(this).valid()) {
        e.preventDefault();
    }
});
// submit form when clicking on [js-form-trigger] element
$(document).on("click change", "[js-form-trigger]", function (e) {
    e.preventDefault();
    $(this).closest("form").submit();
});
// validate form on click [js-form-redirect] element
// active link if form is valid
$(document).on("click change", "[js-form-redirect]", function (e) {
    if ($(this).closest("form").valid()) {
        return true;
    }
    return false;
});
// reset form and submit
$('[js-reset-submit-form-trigger]').click(function () {
    // clear all field and submit
    const form = $(this).closest("form");
    form.find("input").not("[type='hidden']").val('');
    form.submit();
});
// add input mask
document.querySelectorAll('input[data-input-mask]').forEach(element => {
    const inputMask = new InputMask(element);
    inputMask.init();
    // add jquery validation
    $(element).rules('add', {
        mask: inputMask.generateRegex(),
        messages: {
            mask: 'Please complete with format: ' + inputMask.generatePlaceholder() // override error message
        }
    });
});
export default undefined;
